var map = {
	"app/dashboard/dashboard.module.ngfactory": [
		"./src/app/dashboard/dashboard.module.ngfactory.js",
		"common",
		"dashboard.module"
	],
	"app/landing/landing.module.ngfactory": [
		"./src/app/landing/landing.module.ngfactory.js",
		"common",
		"landing.module"
	],
	"app/reporting/reporting.module.ngfactory": [
		"./src/app/reporting/reporting.module.ngfactory.js",
		"common",
		"reporting.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main